export default "__VITE_ASSET__c9d01281__"